import { push, replace } from "react-router-redux";
import urlUtils from "@tinqin/tinqin-utils/src/url";
import internalStateService from "../app/InternalStateService";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
export const UPDATE_ROUTES = "UPDATE_ROUTES";

function updateRoutes(path) {
    return {
        type: UPDATE_ROUTES,
        payload: {
            path: path
        }
    };
}

export function pushRoute(path) {
    return (dispatch, getState) => dispatch(push(path));
}

export function dispatchUpdateRoutes(path) {
    return (dispatch, getState) => {
        if (path) {
            return dispatch(updateRoutes(path));
        }
        return null;
    };
}

export function dispatchUpdateLocation(location, options = {}) {
    return (dispatch, getState) => {
        let currentLocation = getState().getIn(["routes", "location"]);
        let differentLocation;
        if (options.skipLocationCheck) {
            differentLocation = true;
        } else {
            differentLocation = locationChanged(location);
        }
        //don't add new location if it is the same as current F5(reload page)
        if (differentLocation) {
            if (options.replace) {
                dispatch(replace(location));
            } else {
                dispatch(push(location));
            }
            let savedState = JSON.stringify(location.state);
            sessionStorage.setItem("state", savedState);
            return Promise.resolve();
        } else if (!currentLocation) {
            //saving current location from browser history to app store
            //in case of application reload (F5)
            location.state = Object.assign(
                {},
                window.history.state ? window.history.state.state : {},
                location.state
            );
            return dispatch(replace(location));
        }
    };
}

export function setRootPath(path) {
    return {
        type: "SET_ROOT_PATH",
        payload: {
            path: path
        }
    };
}

export function getCurrentLocation() {
    return (dispatch, getState) => {
        let currentLocation = getState().getIn(["routes", "location"]);
        if (!currentLocation) {
            WEBUILogs.warn("Missing current location.");
        }
        return currentLocation ? currentLocation.toJS() : {};
    };
}

export function getCurrentLocationState() {
    return (dispatch) => {
        return dispatch(getCurrentLocation()).state || {};
    };
}

export function updateLocationState(props) {
    return (dispatch, getState) => {
        let currentLocation = getState().getIn(["routes", "location"]);
        if (!currentLocation) {
            WEBUILogs.error("Missing current location.");
            return Promise.reject("Missing current location.");
        }
        let newLocation = currentLocation.toJS();
        let state = newLocation.state;
        Object.keys(props).forEach((prop) => {
            state[prop] = props[prop];
        });
        newLocation.state = state;
        return dispatch(replace(newLocation));
    };
}

export function updateLocationStateDashboard(props) {
    return (dispatch, getState) => {
        let currentLocation = getState().getIn(["routes", "location"]);
        if (!currentLocation) {
            WEBUILogs.error("Missing current location.");
            return Promise.reject("Missing current location.");
        }
        currentLocation = currentLocation.toJS();
        let currentSearch = currentLocation.search;
        let currentPathname = currentLocation.pathname;
        let newLocation = currentLocation;
        let newSearch = urlUtils.updateUrlParameters(currentSearch, props);
        WEBUILogs.log("Updating search parameters: " + newSearch);
        newLocation.search = newSearch;
        //updating current dashboard data
        if (newLocation.state.dashboard) {
            newLocation.state.dashboard.address = currentPathname + newSearch;
        }
        if (newLocation.state.dashboard.configUrl) {
            newLocation.state.dashboard.configUrl = urlUtils.updateUrlParameters(
                newLocation.state.dashboard.configUrl,
                props
            );
        }
        if (newLocation.state.dashboard.dataUrl) {
            newLocation.state.dashboard.dataUrl = urlUtils.updateUrlParameters(
                newLocation.state.dashboard.dataUrl,
                props
            );
        }
        return dispatch(replace(newLocation));
    };
}

export function locationChanged(location) {
    let result;
    switch (internalStateService.getGlobalProperties("dashboardPathname")) {
        case "queryParams":
            result = location.search !== window.location.search;
            break;
        case "pathParams":
            let currentPath = window.location.pathname;
            //remove ROOT_PATH when comparing, since location is relative to ROOT_PATH
            let rootPath = internalStateService.getWebConfig()["ROOT_PATH"];
            if (rootPath !== "/") {
                currentPath = currentPath.replace(rootPath, "");
            }
            let newPath = location.pathname;
            let currentSearch = window.location.search || "";
            let newSearch = location.search || "";
            //remove trailing "/" when comparing
            if (currentPath.endsWith("/")) {
                currentPath = currentPath.slice(0, -1);
            }
            if (newPath.endsWith("/")) {
                newPath = newPath.slice(0, -1);
            }
            result = newPath !== currentPath || newSearch !== currentSearch;
            break;
        default:
            result = location.pathname !== window.location.pathname;
    }
    return result;
}
